import {
    AnalyticsUserEvent,
    DummyExperiment20250910,
    type DummyExperiment20250910_ExperimentParam_Value,
} from '@fruitful/types';
import { useStatsigClient } from '@statsig/expo-bindings';
import React, { useEffect } from 'react';
import {
    BodyMediumEmphasized,
    BodySmallEmphasized,
    BodySmallRegular,
    YStack,
} from 'smoothie';

import { IS_PRODUCTION } from '../../config/FruitfulEnvironment';
import useExperimentAndLog from '../../feature-flags/hooks/useExperimentAndLog';
import { captureMessage, track } from '../../logger/Logger';

export const TempExperimentPoc = () => {
    // Might be nice to wrap a pattern like this in a hook for easy, mostly typed use
    const { client: statsig } = useStatsigClient();

    const pocExperiment = useExperimentAndLog(DummyExperiment20250910.name);

    const pocExperimentParams = pocExperiment.value;

    const pocExperimentValue = pocExperiment.get(
        DummyExperiment20250910.parameters.experiment_param.key,
    ) as DummyExperiment20250910_ExperimentParam_Value | undefined;
    const experimentConversionEventName = 'Test';

    useEffect(() => {
        if (pocExperimentParams == null) {
            return;
        }
        captureMessage(
            `pocExperimentParams: ${JSON.stringify(pocExperimentParams)}`,
        );
    }, [pocExperimentParams]);

    if (pocExperimentParams == null) {
        return null;
    }

    return (
        <YStack
            backgroundColor={
                pocExperimentValue === 'test'
                    ? '$green300'
                    : pocExperimentValue === 'control'
                      ? '$dropletBlue300'
                      : '$red300'
            }
            padding={16}
            borderRadius={20}
            cursor="pointer"
            alignItems="center"
            gap={4}
            opacity={IS_PRODUCTION ? 0 : 1}
            onPress={() => {
                statsig.logEvent(
                    experimentConversionEventName,
                    pocExperimentValue,
                );
                track(AnalyticsUserEvent.FF_DEBUGGING);
            }}
        >
            <BodySmallRegular>(TEMP: hidden in production)</BodySmallRegular>
            <BodySmallRegular>Experiment param value:</BodySmallRegular>
            <BodyMediumEmphasized>
                &quot;{pocExperimentValue}&quot;
            </BodyMediumEmphasized>
            <BodySmallEmphasized>
                Press to log conversion event
            </BodySmallEmphasized>
        </YStack>
    );
};
